export function CmToFtAndInch(length: number): string {
  const convert = length * 0.3937008;
  let FT = convert / 12;
  FT = Math.floor(FT);
  const dif = convert / 12 - FT;
  let INCH = dif / (1 / 12);
  INCH = parseFloat(INCH.toFixed(0));
  if (INCH === 12) {
    FT += 1;
    INCH = 0;
  }
  return `${FT}'${INCH}"`;
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/lengthConvertor.ts